import { createSelector } from "reselect";
import { SharedState } from "../types/SharedState";

const getSessionState = (state: SharedState) => state.session;

export const getActiveEventsOpen = createSelector(
  [getSessionState],
  session => session.activeEventsOpen
);
